<p-fieldset legend="Debug">
      <p-message size="large" severity="error" icon="pi pi-exclamation-triangle">This component is out of date and needs to be fixed.</p-message>
      <p-button label="Test Course Library Launch (w/o Deeplinking)" link 
            (click)="initiateCourseLaunchWithoutDeeplinking()"/>

            <p-button label="Test Course Launch (with Deeplinking)" link 
            (click)="showAlert('This is in progress..')"/>
</p-fieldset>